<template>
  <div class="events-wrapper">
    <div class="bg-number">EVENTS_2026</div>

    <header class="events-header">
      <div class="header-content">
        <div class="pulse-badge">
          <span class="pulse-icon"></span>
          LIVE SHARING / 实讯
        </div>
        <h1>连接<span class="gradient-text">思想</span>的频率</h1>
        <p>在来秋，平均每周产生 12 场跨学科碰撞。从底层代码到数字哲学，每一场沙龙都是一次节点升级。</p>
      </div>
    </header>

    <main class="events-container">
      <div class="filter-bar">
        <button v-for="tab in tabs" :key="tab" :class="['filter-btn', { active: currentTab === tab }]"
          @click="currentTab = tab">
          {{ tab }}
        </button>
      </div>

      <div class="events-grid">
        <div v-for="(event, index) in filteredEvents" :key="index" :class="['event-card', event.statusType]">

          <div class="event-date">
            <span class="day">{{ event.day }}</span>
            <span class="month">{{ event.month }}</span>
          </div>

          <div class="event-info">
            <div class="status-tag">{{ event.statusText }}</div>
            <h3>{{ event.title }}</h3>
            <p class="desc">{{ event.desc }}</p>

            <div class="event-meta">
              <span class="location"><i class="icon">📍</i> {{ event.location }}</span>
              <span class="speaker"><i class="icon">👤</i> {{ event.speaker }}</span>
            </div>

            <div class="attendees">
              <div class="avatar-group">
                <div v-for="i in 5" :key="i" class="mini-avatar"
                  :style="{ backgroundImage: `url(https://i.pravatar.cc/100?img=${i + index * 3})` }">
                </div>
                <div class="more-count">+{{ event.attendeeCount }} 人已加入</div>
              </div>
            </div>
          </div>

          <div class="event-action">
            <div class="ticket-stub"></div>
            <button class="rsvp-btn" :disabled="event.statusType === 'past'">
              {{ event.statusType === 'past' ? '查看回顾' : '预约席位' }}
            </button>
          </div>
        </div>
      </div>

      <div class="load-more">
        <div class="line"></div>
        <button class="ghost-btn">加载历史记录 / ARCHIVE</button>
        <div class="line"></div>
      </div>
    </main>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'

const currentTab = ref('全部活动')
const tabs = ['全部活动', '进行中', '即将开始', '精彩回顾']

const events = [
  {
    day: '14', month: 'APR',
    title: '深度学习中的“非线性”美学思考',
    desc: '邀请 Google 架构师探讨模型参数背后的艺术感官。',
    location: '上海 · 莫干山路 M50 / 线上同步',
    speaker: 'Dr. Zhang (Senior Architect)',
    attendeeCount: 128,
    statusText: '正在直播 LIVE',
    statusType: 'live'
  },
  {
    day: '18', month: 'APR',
    title: 'Web3 创作者协议：如何实现真正的数字确权？',
    desc: '闭门研讨会：针对来秋社区自研协议 v2.0 的压力测试报告。',
    location: 'Metaverse / 节点 09',
    speaker: 'Archie (Laiqiu Lab)',
    attendeeCount: 450,
    statusText: '预约中 OPEN',
    statusType: 'open'
  },
  {
    day: '22', month: 'APR',
    title: '极简主义 UI 与高性能渲染的博弈',
    desc: '从 Canvas 到 WebGL，如何用最少的代码实现最震撼的视觉。',
    location: '线上直播间',
    speaker: 'Seven (Design Director)',
    attendeeCount: 89,
    statusText: '预约中 OPEN',
    statusType: 'open'
  },
  {
    day: '08', month: 'APR',
    title: 'Rust 与系统级开发的未来',
    desc: '回顾：为什么我们决定将底层架构全面转向 Rust。',
    location: '杭州 · 西溪云谷',
    speaker: 'Leon (CTO)',
    attendeeCount: 1024,
    statusText: '已结束 ENDED',
    statusType: 'past'
  }
]

const filteredEvents = computed(() => {
  if (currentTab.value === '全部活动') return events
  if (currentTab.value === '进行中') return events.filter(e => e.statusType === 'live')
  if (currentTab.value === '即将开始') return events.filter(e => e.statusType === 'open')
  if (currentTab.value === '精彩回顾') return events.filter(e => e.statusType === 'past')
  return events
})
</script>

<style scoped>
.events-wrapper {
  background: #050505;
  color: #fff;
  min-height: 100vh;
  padding: 120px 0 100px;
  font-family: 'Inter', sans-serif;
  position: relative;
  overflow: hidden;
}

.bg-number {
  position: absolute;
  top: 50px;
  right: -50px;
  font-size: 15rem;
  font-weight: 900;
  color: rgba(109, 93, 252, 0.03);
  z-index: 0;
  user-select: none;
}

/* 头部设计 */
.events-header {
  max-width: 1200px;
  margin: 0 auto 80px;
  padding: 0 20px;
  position: relative;
  z-index: 1;
}

.pulse-badge {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: rgba(109, 93, 252, 0.1);
  border: 1px solid rgba(109, 93, 252, 0.3);
  padding: 6px 16px;
  border-radius: 20px;
  font-family: monospace;
  font-size: 0.8rem;
  color: #6d5dfc;
  margin-bottom: 25px;
}

.pulse-icon {
  width: 8px;
  height: 8px;
  background: #6d5dfc;
  border-radius: 50%;
  animation: pulse-glow 1.5s infinite;
}

@keyframes pulse-glow {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(109, 93, 252, 0.7);
  }

  70% {
    transform: scale(1.2);
    box-shadow: 0 0 0 10px rgba(109, 93, 252, 0);
  }

  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(109, 93, 252, 0);
  }
}

.events-header h1 {
  font-size: 3.5rem;
  font-weight: 800;
  margin-bottom: 20px;
}

.gradient-text {
  background: linear-gradient(90deg, #6d5dfc, #00d2ff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.events-header p {
  max-width: 600px;
  font-size: 1.1rem;
  color: rgba(255, 255, 255, 0.5);
  line-height: 1.6;
}

/* 过滤器 */
.filter-bar {
  max-width: 1200px;
  margin: 0 auto 40px;
  padding: 0 20px;
  display: flex;
  gap: 20px;
}

.filter-btn {
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.4);
  font-size: 1rem;
  cursor: pointer;
  padding: 10px 0;
  position: relative;
  transition: 0.3s;
}

.filter-btn.active {
  color: #fff;
}

.filter-btn.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: #6d5dfc;
}

/* 列表展示 */
.events-container {
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

.events-grid {
  display: flex;
  flex-direction: column;
  gap: 25px;
  padding: 0 20px;
}

.event-card {
  display: grid;
  grid-template-columns: 120px 1fr 200px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  overflow: hidden;
  transition: 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
  backdrop-filter: blur(10px);
}

.event-card:hover {
  background: rgba(255, 255, 255, 0.06);
  border-color: rgba(109, 93, 252, 0.4);
  transform: translateX(10px);
}

/* 卡片日期部分 */
.event-date {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(109, 93, 252, 0.05);
  border-right: 1px dashed rgba(255, 255, 255, 0.1);
}

.event-date .day {
  font-size: 2.5rem;
  font-weight: 800;
}

.event-date .month {
  font-size: 0.8rem;
  opacity: 0.5;
  letter-spacing: 2px;
}

/* 卡片内容部分 */
.event-info {
  padding: 30px;
}

.status-tag {
  font-family: monospace;
  font-size: 0.75rem;
  margin-bottom: 12px;
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
}

.live .status-tag {
  color: #ff007a;
  border: 1px solid #ff007a;
}

.open .status-tag {
  color: #00ff9d;
  border: 1px solid #00ff9d;
}

.past .status-tag {
  color: rgba(255, 255, 255, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.event-info h3 {
  font-size: 1.5rem;
  margin-bottom: 15px;
}

.desc {
  color: rgba(255, 255, 255, 0.5);
  font-size: 0.95rem;
  margin-bottom: 20px;
  line-height: 1.6;
}

.event-meta {
  display: flex;
  gap: 30px;
  font-size: 0.85rem;
  opacity: 0.6;
  margin-bottom: 25px;
}

/* 参与者头像 */
.attendees {
  display: flex;
  align-items: center;
}

.avatar-group {
  display: flex;
  align-items: center;
}

.mini-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 2px solid #050505;
  margin-right: -10px;
  background-size: cover;
}

.more-count {
  margin-left: 20px;
  font-size: 0.8rem;
  color: #6d5dfc;
  font-weight: 600;
}

/* 卡片操作部分 */
.event-action {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background: rgba(255, 255, 255, 0.02);
  border-left: 1px dashed rgba(255, 255, 255, 0.1);
}

.ticket-stub {
  position: absolute;
  top: 50%;
  left: -8px;
  width: 16px;
  height: 16px;
  background: #050505;
  border-radius: 50%;
  transform: translateY(-50%);
}

.rsvp-btn {
  padding: 12px 24px;
  border-radius: 8px;
  border: none;
  font-weight: bold;
  cursor: pointer;
  transition: 0.3s;
  background: #fff;
  color: #000;
}

.rsvp-btn:hover:not(:disabled) {
  background: #6d5dfc;
  color: #fff;
  box-shadow: 0 0 20px rgba(109, 93, 252, 0.4);
}

.rsvp-btn:disabled {
  background: rgba(255, 255, 255, 0.05);
  color: rgba(255, 255, 255, 0.2);
  cursor: not-allowed;
}

/* 底部加载 */
.load-more {
  margin-top: 60px;
  display: flex;
  align-items: center;
  gap: 20px;
  opacity: 0.3;
}

.line {
  flex: 1;
  height: 1px;
  background: rgba(255, 255, 255, 0.2);
}

.ghost-btn {
  background: transparent;
  border: 1px solid #fff;
  color: #fff;
  padding: 10px 20px;
  border-radius: 4px;
  font-size: 0.8rem;
  cursor: pointer;
}

/* 响应式适配 */
@media (max-width: 992px) {
  .event-card {
    grid-template-columns: 1fr;
  }

  .event-date {
    padding: 20px;
    flex-direction: row;
    gap: 15px;
    border-right: none;
    border-bottom: 1px dashed rgba(255, 255, 255, 0.1);
    justify-content: flex-start;
  }

  .event-action {
    border-left: none;
    border-top: 1px dashed rgba(255, 255, 255, 0.1);
    padding: 30px;
  }

  .ticket-stub {
    display: none;
  }
}
</style>